import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { Redirect } from '@mews-commander/ui';
import { MewsTeam, PlatformEnvironment, RouteType } from '@mews/enums';
import { useEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useFeatureFlag } from '@mews/framework';
import { useAppConfiguration } from '@mews-commander/data-access';

const Component = () => {
    const { currentEnterpriseId } = Route.useParams();
    const enterprise = useEnterprise(currentEnterpriseId);
    const isOnboardingCompletionCheckEnabled = useFeatureFlag(FeatureFlag.onboardingCompletionCheckEnabled);
    const { environment } = useAppConfiguration();
    const isDemoEnvironment = environment === PlatformEnvironment.Demo;

    if (!enterprise.isOnboardingFinished && isOnboardingCompletionCheckEnabled && !isDemoEnvironment) {
        return <Redirect to="/$currentEnterpriseId/Settings/GoLiveAudits/Setup" params={{ currentEnterpriseId }} />;
    }

    return <Redirect to="/$currentEnterpriseId/Dashboard/Index" params={{ currentEnterpriseId }} />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Dashboard/Redirect')({
    component: Component,
    staticData: {
        routeName: RouteName.DashboardRedirect,
        title: TextKey.Dashboard,
        owner: MewsTeam.Accounts,
        type: RouteType.Redirect,
    },
});
